/**
 * Formatação monetária a partir de centavos (INTEGER) — DOC 05 / 12.
 * F1: BRL; currency vem do plano quando existir.
 */
export const formatCents = (
  cents: number,
  currency: string = "BRL",
  locale: string = "pt-BR"
): string => {
  const amount = (Number.isFinite(cents) ? cents : 0) / 100;
  try {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currency || "BRL",
    }).format(amount);
  } catch {
    // Moeda inválida → fallback BRL.
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: "BRL",
    }).format(amount);
  }
};

/**
 * Custo por 1.000 envios no teto da cota — ajuda a comparar planos (DOC 10).
 * Retorna null se cota inválida (não inventa número).
 */
export const formatCentsPerThousand = (
  cents: number,
  emailQuota: number,
  currency: string = "BRL",
  locale: string = "pt-BR"
): string | null => {
  if (!Number.isFinite(cents) || !Number.isFinite(emailQuota) || emailQuota <= 0) {
    return null;
  }
  const perThousandCents = Math.round((cents / emailQuota) * 1000);
  return formatCents(perThousandCents, currency, locale);
};

/** Locale i18next → tag BCP 47 para Intl. */
export const intlLocaleFromI18n = (language: string): string => {
  if (language === "en") return "en-US";
  if (language === "es") return "es-ES";
  return "pt-BR";
};

/**
 * Converte digitação em reais (`29,90` / `29.90`) → centavos INTEGER.
 * Por quê: SA digita em R$; API só aceita base_price_cents.
 */
export const parseReaisToCents = (raw: string): number | null => {
  let s = raw.trim().replace(/\s/g, "");
  if (!s) {
    return null;
  }

  if (s.includes(",") && s.includes(".")) {
    // 1.234,56 → remove milhar, vírgula vira decimal
    s = s.replace(/\./g, "").replace(",", ".");
  } else if (s.includes(",")) {
    s = s.replace(",", ".");
  }

  const n = Number(s);
  if (!Number.isFinite(n) || n < 0) {
    return null;
  }

  return Math.round(n * 100);
};

/** Centavos → string de input (duas casas, vírgula BR). */
export const centsToReaisInput = (cents: number): string => {
  const amount = (Number.isFinite(cents) ? cents : 0) / 100;
  return amount.toFixed(2).replace(".", ",");
};
